import React, { useState } from "react";

const Modal = ({ informationTitle, informationText }) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<span className="information-modal">
			<div
				aria-hidden="true"
				className="js-dialog-backdrop"
				id="js-dialog-backdrop"
				style={isOpen ? { display: "block" } : {}}
				onClick={() => setIsOpen(false)}
			></div>
			<div className="js-dialog base js" role="dialog" id="js-dialog" open={isOpen}>
				<div className="modal">
					<header className="header">
						<span className="title">
							<p className="text lead medium nospace bold">{informationTitle}</p>
						</span>
						<span className="control">
							
							<button
								type="button"
								onClick={() => setIsOpen(false)}
							> test
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="icon"
									viewBox="0 0 24 24"
								>
									<title>cross</title>
									<g
										fill="none"
										stroke="currentColor"
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth="2"
									>
										<line x1="18" y1="6" x2="6" y2="18" />
										<line x1="6" y1="6" x2="18" y2="18" />
									</g>
								</svg>
							</button>
						</span>
					</header>
					<section className="main"> <div className="text" dangerouslySetInnerHTML={{ __html: informationText }} /></section>
				</div>
			</div>
			<div className="information-button" onClick={() => setIsOpen(true)}>
				<img className="information-icon" src="https://static.tui.com/assets/v2/icons/tui/question-mark-circled.svg" />
			</div>
		</span>
	);
};

export default Modal;
